import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import Dictionary from "../../../domains/Dictionary";
import HistoricalMeans from "../../../domains/HistoricalMeans";
import { SLICE_NAME } from "./types";

interface HistoricalMeansState {
  historicalMeans: Dictionary<HistoricalMeans>
  areHistoricalMeansLoading: boolean
  hasErrorLoadingHistoricalMeans: boolean
  isHistoricalMeansAlertOpen: boolean
}

const initialState: HistoricalMeansState = {
  historicalMeans: {},
  areHistoricalMeansLoading: false,
  hasErrorLoadingHistoricalMeans: false,
  isHistoricalMeansAlertOpen: false,
};

export const historicalMeansSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    getHistoricalMeans: state => {
      state.areHistoricalMeansLoading = true;
    },
    getHistoricalMeansSuccess: (
      state,
      action: PayloadAction<Dictionary<HistoricalMeans>>,
    ) => {
      state.areHistoricalMeansLoading = false;
      state.historicalMeans = action.payload;
    },
    getHistoricalMeansError: state => {
      state.areHistoricalMeansLoading = false;
      state.hasErrorLoadingHistoricalMeans = false;
    },
    openHistoricalMeansAlert: state => {
      state.isHistoricalMeansAlertOpen = true;
    },
    closeHistoricalMeansAlert: state => {
      state.isHistoricalMeansAlertOpen = false;
    },
  },
});

export const {
  getHistoricalMeans,
  getHistoricalMeansSuccess,
  getHistoricalMeansError,
  openHistoricalMeansAlert,
  closeHistoricalMeansAlert,
} = historicalMeansSlice.actions;

export default historicalMeansSlice.reducer;
